import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetChargingSessionsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/charging-sessions/get-charging-sessions-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchEmspBoChargingSessionListContext } from '../../emsp-bo-charging-session.context';
import { EmspBoChargingSessionListFilterSearchFormStep1Controller } from '../emsp-bo-charging-session-list-filter-search-form-step-1/emsp-bo-charging-session-list-filter-search-form-step-1.controller';

export interface EmspBoChargingSessionListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetChargingSessionsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetChargingSessionsPaginatedModel>;
  onCancel: () => void;
}

export const EmspBoChargingSessionListFilterSearchFormController = (
  props: EmspBoChargingSessionListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchEmspBoChargingSessionListContext();

  return (
    <HeadlessFormProvider<GetChargingSessionsPaginatedModel>
      useFormProps={{
        mode: 'all',
        defaultValues: data,
      }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <EmspBoChargingSessionListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
